import axios from 'axios';
import AppConfig from "../../../config/AppConfig";

function getBaseURL() {
	return AppConfig.erp_server
}

const instance = axios.create({
  baseURL: getBaseURL() + '/contract/'
});

const ErrorResponse = {code: 400, msg: '网络错误'}

instance.interceptors.request.use(function (config) {
  if(!config.params) config.params = {}
  config.params.login_name = localStorage.getItem('login')
  config.params.token = localStorage.getItem('token')
  return config;
});

function DateFormat(date) {
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let sdate = ("0" + date.getDate()).slice(-2);
  return year + '-' + month + '-' + sdate
}

function get(url, data, callback) {
  instance.get(url, {params: data}).then(resp => {
    callback(resp.data)
  }).catch(error => callback(ErrorResponse))
}

function post(url, data, callback) {
  instance.post(url, data).then(resp => {
    callback(resp.data)
  }).catch(error => callback(ErrorResponse))
}

const Area = {

  getAreaList(data, callback) {
    get('area/getAreaList', data, callback)
  },

  saveArea(data, callback) {
    post('area/saveArea', data, callback)
  },

  getAreaFullName(data, callback) {
    get('area/getAreaFullName', data, callback)
  },

  deleteArea(data, callback) {
    post('area/deleteArea', data, callback)
  },

}

const Partnership = {

  getList(data, callback) {
    get('Partnership/getList', data, callback)
  },

  save(data, callback) {
    post('Partnership/save', data, callback)
  },

  getFullName(data, callback) {
    get('Partnership/getFullName', data, callback)
  },

  delete(data, callback) {
    post('Partnership/delete', data, callback)
  },

}

const Business = {

  getBusinessList(data, callback) {
    get('business/getBusinessList', data, callback)
  },

  saveBusiness(data, callback) {
    post('business/saveBusiness', data, callback)
  },

  deleteBusiness(data, callback) {
    post('business/deleteBusiness', data, callback)
  },

}


export {
  getBaseURL,
  DateFormat,
  Area,
  Business,
  Partnership,
  get,
  post,
}



// WEBPACK FOOTER //
// ./src/components/Admin/Contract/common.js